import React from "react";

interface IsaacTextInputProps {
  newValue: string;
  handleValueChanged: (value: string) => void;
  handleBlur: () => void;
}

const IsaacTextInput: React.FunctionComponent<IsaacTextInputProps> = ({newValue, handleValueChanged, handleBlur}) => {
  return (
    <input
      value={newValue ?? ""}
      type="text"
      onBlur={handleBlur}
      onChange={e => {
        handleValueChanged(e.target.value);
      }}
    />
  );
};

export default IsaacTextInput;
